@if (placeholderObj) {
  @if (isTextPlaceholderType()) {
    <span
      class="text relative overflow-hidden overflow-ellipsis"
      [innerHTML]="placeholderObj.value | translate: placeholderParamsObj">
    </span>
    @if (placeholderIcon) {
      <svg-icon preserveAspectRatio="none" [stretch]="true" [src]="placeholderIcon"></svg-icon>
    }
  } @else {
    <ng-container *ngTemplateOutlet="placeholderObj.value"></ng-container>
  }
}
